//
export const AuthenUserMock = {
  user: {
    username: 'nguyenthilan',
    password: '123qwe@..',
    accountType: 'NHAN_VIEN'
  },
  loginResponse: {
    token: 'ey...',
    user: {
      id: '12398415936892',
      image: '',
      ho_ten: 'nguyenthilan',
      email: 'nguyenthilan@gmail.com',
    },
    menu: [''],
  },
  appKey: 'MOBILE_HUTECH',
};


// export const AuthenUserMock = {
//   user: {
//     username: 'NNV0050588',
//     password: '123qwe@..',
//     accountType: 'NHAN_VIEN'
//   },
//   loginResponse: {
//     token: 'ey...',
//     user: {
//       id: '12398415936892',
//       image: '',
//       ho_ten: 'Developer',
//       email: 'Developer@gmail.com',
//     },
//     menu: [300038, 300036, 300037, 300039],
//   },
//   appKey: 'ROYAL_EDURA',
// };
